import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "../../../store/actions/index";
import axios from '../../../axios-private';

import {Container, Row, Col, Form, Button, Table, Alert} from 'react-bootstrap';
import Spinner from '../../../components/UI/Spinner/Spinner'

const StationDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [stationData, setStationData] = useState({
    id: 0,
    stationId: "",
    latitude: 0,
    longitude: 0,
    locationStartDate: "",
    city: "",
    country: "",
    locationAddress: "",
    lastActiveTime: "",

    userId: "",
    currentUsersStationId: null,
    ownershipEvent: "",
    ownershipEventOn: "",

    feederUsername: "",
    feederEmail: "",
    feederName: "",    
    feederSurname: "",
    feederPhone: "",
    startDate: "",
    description: "",
    notificationEmail: "",
    feederNotificationEmail: "DoNothing",
    firstTimeSentToFeeder: ""
  });
  const [stationDataLoading, setStationDataLoading] = useState(true);

  const [usersStationData, setUsersStationData] = useState([]);
  const [usersStationDataLoading, setUsersStationDataLoading] = useState(true);

  const [stationLocationData, setStationLocationData] = useState([]);
  const [stationLocationDataLoading, setStationLocationDataLoading] = useState(true);

    const [releaseDate, setReleaseDate] = useState(() => {
        return new Date().toISOString().slice(0, 10);
    });

    const [releaseNote, setReleaseNote] = useState(
    "Released to inventory from legacy/manual assignment"
    );

    const [releaseBusy, setReleaseBusy] = useState(false);
    const [releaseSuccess, setReleaseSuccess] = useState(null);
    const [releaseError, setReleaseError] = useState(null);

  useEffect(() => {
    //if (id) {
    dispatch(actions.fetchStation(id))
        .then((station) => {
            setStationDataLoading(false);
            if (station) {
                setStationData({
                id: station.id,
                stationId: station.stationId,
                latitude: station.latitude,
                longitude: station.longitude,
                locationStartDate: station.locationStartDate || '',
                city: station.city || '',
                country: station.country || '',
                locationAddress: station.locationAddress || '',
                lastActiveTime: station.lastActiveTime || '',

                userId: station.userId || "",
                currentUsersStationId: station.currentUsersStationId || null,
                ownershipEvent: station.ownershipEvent || "",
                ownershipEventOn: station.ownershipEventOn || "",

                feederUsername: station.feederUsername || '',
                feederEmail: station.feederEmail || '',
                feederName: station.feederName || '',
                feederSurname: station.feederSurname || '',
                feederPhone: station.feederPhone || '',
                startDate: station.startDate || '',
                description: station.description || '',
                notificationEmail: station.notificationEmail || '',
                feederNotificationEmail: station.feederNotificationEmail || "DoNothing",
                firstTimeSentToFeeder: station.firstTimeSentToFeeder || ''
                });
            } else {
                setStationDataLoading(false);
                console.error("Station data is undefined or null");
            }
        })
        .catch((error) => {
            console.error("Error while fetching station data:", error);
        });
    //}
    axios.get(`/Station/GetStationFeederHistory/${id}`)
        .then(response => {
            setUsersStationDataLoading(false);
            setUsersStationData(response.data);            
        })
        .catch(error => {
            setUsersStationDataLoading(false);
            console.error("Error while fetching station's feeder history data:", error);
        });

    axios.get(`/Station/GetStationLocationHistory/${id}`)
        .then(response => {
            setStationLocationDataLoading(false);
            setStationLocationData(response.data);            
        })
        .catch(error => {
            setStationLocationDataLoading(false);
            console.error("Error while fetching station's location history data:", error);
        })
    }, []);

    const releasedOnUtcFromDate = (dateString) => {
        return `${dateString}T00:00:00Z`;
    };

    const canReleaseToInventory =
        stationData.id > 0 &&
        stationData.currentUsersStationId != null &&
        stationData.feederUsername &&
        stationData.ownershipEvent !== "Returned";

    const handleReleaseToInventory = async () => {
        if (!releaseDate) {
            setReleaseError("Release date is required.");
            return;
        }

        if (!stationData.currentUsersStationId) {
            setReleaseError(
                "CurrentUsersStationId is missing. Backend Station/GetStation response must include currentUsersStationId."
            );
            return;
        }

        const ok = window.confirm(
            `Release station ${stationData.stationId} to inventory?\n\n` +
            `Current feeder: ${stationData.feederUsername || "—"}\n` +
            `Release date: ${releaseDate}\n\n` +
            "This will close the current UsersStation relationship, insert a Returned ownership event, rotate the PIN, and make the receiver available for new receiver requests."
        );

        if (!ok) return;

        setReleaseBusy(true);
        setReleaseError(null);
        setReleaseSuccess(null);

        try {
            await dispatch(actions.releaseStationToInventory({
                stationDbId: stationData.id,
                releasedOnUtc: releasedOnUtcFromDate(releaseDate),
                note: releaseNote?.trim() || "Released to inventory from legacy/manual assignment",
                expectedCurrentUsersStationId: stationData.currentUsersStationId
            }));

            setReleaseSuccess("Station released to inventory successfully.");

            // Reload to refresh station snapshot, feeder history, and location history.
            window.location.reload();
        } catch (error) {
            setReleaseError(
                error?.response?.data?.message ||
                error?.response?.data ||
                error.message ||
                "Release to inventory failed."
            );
        } finally {
            setReleaseBusy(false);
        }
    };

    
//   }, [dispatch, id]);

//   const onUpdateStation = useCallback(() => {
//     const payload = {
//       id: stationData.id,
//       latitude: parseFloat(stationData.latitude) || 0,
//       longitude: parseFloat(stationData.longitude) || 0,
//       city: stationData.city,
//       country: stationData.country,
//       locationAddress: stationData.locationAddress,
//       feederName: stationData.feederName,
//       feederEmail: stationData.feederEmail,
//       feederPhone: stationData.feederPhone,
//       description: stationData.description,
//       feederNotificationEmail: stationData.feederNotificationEmail === "DoNothing"
//         ? "DoNothing"
//         : stationData.feederNotificationEmail,
//     };

//     dispatch(actions.updateStation(payload))
//       .then(() => {
//         history.push(`/statistics?stationId=${stationData.stationId}`);
//       })
//       .catch((error) => {
//         console.error("Error updating station:", error);
//       });
//   }, [
//     dispatch,
//     stationData,
//     history
//   ]);

//   const onSubmit = (e) => {
//     e.preventDefault();
//     onUpdateStation();
//   };

let stationDetailsForm = <Spinner />;
if (stationData.id == 0 && !stationDataLoading) {
    stationDetailsForm = <p style={{ textAlign: 'center', color:'red', marginTop:'65px' }}>Could not read station details from the server!</p>;
}
if (stationData.id != 0 && !stationDataLoading) {
    stationDetailsForm = 
        <Form >
            <Form.Group className="mb-1">
                <Form.Label>ID</Form.Label>
                <Form.Control
                // className={classes.input}
                //id="id"
                value={stationData.id}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Station ID</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="stationId"
                value={stationData.stationId}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Latitude</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="latitude"
                value={stationData.latitude}
                //onChange={(e) => setStationData({ ...stationData, latitude: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Longitude</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="longitude"
                value={stationData.longitude}
                //onChange={(e) => setStationData({ ...stationData, longitude: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Geolocation start date</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederPhone"
                value={new Date(stationData.locationStartDate).toLocaleString()}
                //onChange={(e) => setStationData({ ...stationData, feederPhone: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>City</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="city"
                value={stationData.city}
                //onChange={(e) => setStationData({ ...stationData, city: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Country</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="country"
                value={stationData.country}
                //onChange={(e) => setStationData({ ...stationData, country: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Location Address</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="locationAddress"
                value={stationData.locationAddress}
                //onChange={(e) => setStationData({ ...stationData, locationAddress: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Last Active Time</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="lastActiveTime"
                value={new Date(stationData.lastActiveTime).toLocaleString()}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder username</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederName"
                value={stationData.feederUsername}
                //onChange={(e) => setStationData({ ...stationData, feederName: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder Email</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederEmail"
                value={stationData.feederEmail}
                //onChange={(e) => setStationData({ ...stationData, feederEmail: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder Name</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederName"
                value={stationData.feederName}
                //onChange={(e) => setStationData({ ...stationData, feederName: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder surname</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederName"
                value={stationData.feederSurname}
                //onChange={(e) => setStationData({ ...stationData, feederName: e.target.value })}
                disabled
                type="text"
                required
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder Phone</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederPhone"
                value={stationData.feederPhone}
                //onChange={(e) => setStationData({ ...stationData, feederPhone: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Feeder start date</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="feederPhone"
                value={new Date(stationData.startDate).toLocaleString()}
                //onChange={(e) => setStationData({ ...stationData, feederPhone: e.target.value })}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Ownership event</Form.Label>
                <Form.Control
                    value={
                    stationData.ownershipEvent
                        ? `${stationData.ownershipEvent} (${stationData.ownershipEventOn ? new Date(stationData.ownershipEventOn).toLocaleString() : "—"})`
                        : "—"
                    }
                    disabled
                    type="text"
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Description</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="description"
                value={stationData.description}
                //onChange={(e) => setStationData({ ...stationData, description: e.target.value })}
                disabled
                as="textarea"
                style={{
                    resize: "none",       // Prevent manual resizing
                    overflow: "hidden",    // Hide scrollbars if not needed
                    whiteSpace: "pre-wrap", // Wrap text and preserve formatting
                    wordWrap: "break-word", // Ensure long words break correctly
                    height: "auto",        // Auto adjust height
                    minHeight: "50px"     // Set a minimum height
                  }}
                />
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>Notification Email</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="notificationEmail"
                value={stationData.notificationEmail}
                disabled
                type="text"
                />
            </Form.Group>
            <Form.Group className="mb-3 mt-3">
                <Form.Label className="mr-3">Feeder Notification Email</Form.Label>
                <Form.Select
                // className={classes.input}
                // id="feederNotificationEmail"
                value={stationData.feederNotificationEmail}
                //onChange={(e) => setStationData({ ...stationData, feederNotificationEmail: e.target.value })}
                disabled
                style={{
                    height: 'calc(1.5em + 0.75rem + 2px)', // Match Form.Control height
                    borderRadius: '0.375rem', // Match Form.Control border-radius
                }}
                >
                <option value="Send">Send</option>
                <option value="DoNothing">Do Nothing</option>
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-1">
                <Form.Label>First Time Sent to Feeder</Form.Label>
                <Form.Control
                // className={classes.input}
                // id="firstTimeSentToFeeder"
                value={new Date(stationData.firstTimeSentToFeeder).toLocaleString()}
                disabled
                type="text"
                />
            </Form.Group>            
        </Form>;
}

let usersStationTable = <Spinner />;
// if (usersStationData.length == 0 && !usersStationDataLoading) {
//     usersStationTable = <p style={{ textAlign: 'center', color:'red', marginTop:'65px' }}>Could not read station's feeder history from the server!</p>;
// }
if (!usersStationDataLoading) {
    usersStationTable = 
        <tbody>
        {usersStationData.map((item, index) => (
            <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.userName || 'N/A'}</td>
            <td>{new Date(item.startDate).toLocaleString()}</td>
            <td>
            {item.endDate
                ? new Date(item.endDate).toLocaleString()
                : item.ownershipEvent === "Returned" && item.ownershipEventOn
                    ? new Date(item.ownershipEventOn).toLocaleString()
                    : "Current"}
            </td>
            <td>{item.note || 'N/A'}</td>
            <td>
                {item.createdOn
                ? new Date(item.createdOn).toLocaleString()
                : 'N/A'}
            </td>
            <td>{item.createdByUsername || 'N/A'}</td>
            </tr>
        ))}
        </tbody>;
}

let stationLocationTable = <Spinner />;
// if (usersStationData.length == 0 && !usersStationDataLoading) {
//     usersStationTable = <p style={{ textAlign: 'center', color:'red', marginTop:'65px' }}>Could not read station's feeder history from the server!</p>;
// }
if (!stationLocationDataLoading) {
    stationLocationTable = 
        <tbody>
        {stationLocationData.map((item, index) => (
            <tr key={index}>
            <td>{index + 1}</td>
            <td>{!isNaN(item.latitude) ? item.latitude : 'N/A'}</td>
            <td>{!isNaN(item.longitude) ? item.longitude : 'N/A'}</td>
            <td>{item.city || 'N/A'}</td>
            <td>{item.country || 'N/A'}</td>
            <td>{item.locationAddress || 'N/A'}</td>
            <td>{new Date(item.startDate).toLocaleString()}</td>
            <td>
                {item.createdOn
                ? new Date(item.createdOn).toLocaleString()
                : 'N/A'}
            </td>
            <td>{item.createdByUsername || 'N/A'}</td>
            </tr>
        ))}
        </tbody>;
}

return (
    // <div className={classes.form}>
    <div>
      <h2>Station Details</h2>
      {/* <div className={classes.container}> */}
      <Container fluid className="my-4"> 
        <Row>
            <Col md={3} className="border-end">
                {stationDetailsForm}
            </Col>
            <Col md={9}>
                <Row className="mb-4">
                    <Col>
                        <Button
                        variant="primary"
                        className="mt-3 me-3 mb-3"
                        onClick={() => history.push(`/updateStation/${id}`)}
                        >
                        Update Station
                        </Button>
                    </Col>
                    </Row>

                    <Row className="mb-4">
                    <Col>
                        <div className="border rounded p-3">
                        <h5>Release to inventory</h5>

                        <div className="text-muted mb-2">
                            Use this only for legacy/manual receivers that do not have a ReceiverRequest.
                            This closes the current feeder relationship and makes the receiver available
                            for the new receiver request workflow.
                        </div>

                        {releaseError && <Alert variant="danger">{releaseError}</Alert>}
                        {releaseSuccess && <Alert variant="success">{releaseSuccess}</Alert>}

                        <Row className="g-2">
                            <Col md={4}>
                            <Form.Group>
                                <Form.Label>Current feeder</Form.Label>
                                <Form.Control
                                value={
                                    stationData.feederUsername
                                    ? `${stationData.feederUsername}${stationData.feederEmail ? ` (${stationData.feederEmail})` : ""}`
                                    : "—"
                                }
                                disabled
                                />
                            </Form.Group>
                            </Col>

                            <Col md={3}>
                            <Form.Group>
                                <Form.Label>Release date</Form.Label>
                                <Form.Control
                                type="date"
                                value={releaseDate}
                                onChange={(e) => setReleaseDate(e.target.value)}
                                disabled={releaseBusy}
                                />
                            </Form.Group>
                            </Col>

                            <Col md={5}>
                            <Form.Group>
                                <Form.Label>Note</Form.Label>
                                <Form.Control
                                value={releaseNote}
                                onChange={(e) => setReleaseNote(e.target.value)}
                                maxLength={500}
                                disabled={releaseBusy}
                                />
                            </Form.Group>
                            </Col>
                        </Row>

                        <div className="mt-3">
                            <Button
                            variant="warning"
                            disabled={!canReleaseToInventory || releaseBusy}
                            onClick={handleReleaseToInventory}
                            >
                            {releaseBusy ? "Releasing…" : "Release to inventory"}
                            </Button>
                        </div>

                        {!canReleaseToInventory && (
                            <div className="text-muted mt-2">
                            <small>
                                Release is available only when the station currently has an active feeder relationship
                                and has not already been returned.
                            </small>
                            </div>
                        )}

                        <div className="text-muted mt-2">
                            <small>
                            CurrentUsersStationId: {stationData.currentUsersStationId || "—"}
                            </small>
                        </div>
                        </div>
                    </Col>
                    </Row>
                <Row className="mb-4">                    
                    <Col>
                        <h5>Feeder history</h5>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Username</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Note</th>
                                <th>Created On</th>
                                <th>Created By</th>
                            </tr>
                            </thead>
                            {usersStationTable}
                        </Table>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h5>Location history</h5>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>City</th>
                                <th>Country</th>
                                <th>Location Address</th>
                                <th>Start Date</th>
                                <th>Created On</th>
                                <th>Created By</th>
                            </tr>
                            </thead>
                            {stationLocationTable}
                        </Table>
                    </Col>
                </Row>
            </Col>
        </Row>
        </Container>
      {/* </div> */}
    </div>
  );
};

export default StationDetails;
